import {
   ChangeDetectionStrategy,
   ChangeDetectorRef,
   Component,
   DoCheck,
   Input,
   OnDestroy,
   OnInit,
   ViewEncapsulation,
} from '@angular/core';
import {
   ControlContainer,
   FormGroupDirective,
   NG_VALUE_ACCESSOR,
   UntypedFormArray,
   UntypedFormControl,
   UntypedFormGroup,
} from '@angular/forms';
import { ExtensionTypes } from 'generated/graphql-types';
import { copyNameControlToShortNameAndDisplayName } from 'src/app/common-components/helpers/extension-form-helper';
import { ExtensionOption } from 'src/app/pages/extension-register/models/extension-option.interface';
import { ExtensionDetailView } from '../../models/extension-detail-view.model';
import { ExtensionTypeDetails } from '../../models/extension-type-details';
import { GetExtensionDetail_extension_extensionPagingGroup } from '../../queries/generated/GetExtensionDetail';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    providers: [{ multi: true, provide: NG_VALUE_ACCESSOR, useExisting: ExtensionPagingGroupDetailsComponent }],
    selector: 'ndt-extension-paging-group-details',
    styleUrls: ['./extension-paging-group-details.component.scss'],
    templateUrl: './extension-paging-group-details.component.html',
    standalone: false
})
export class ExtensionPagingGroupDetailsComponent extends ExtensionTypeDetails implements OnInit, OnDestroy, DoCheck {
   @Input() extensionPagingGroup: GetExtensionDetail_extension_extensionPagingGroup | null;

   @Input() extensionId: number | null;

   @Input() extension: ExtensionDetailView | null;

   @Input() extensions: [] | null;

   @Input() extensionGroups: [] | null;

   @Input() accountId: number;

   @Input() set canEdit(edit: boolean) {
      if (!edit) {
         this.form?.disable();
      } else {
         this.form?.enable();
      }
      this._canEdit = edit;
   }

   get canEdit(): boolean {
      return this._canEdit;
   }

   form: UntypedFormGroup;

   searchControl = new UntypedFormControl('');

   pagingGroupExtensionTypes = [ExtensionTypes.Phone];

   extensionIdsToExclude: number[] = [];

   extensionGroupIdsToExclude: number[] = [];

   get pagingGroupMembers(): UntypedFormArray {
      const pagingGroupMembers = this.form.get('pagingGroupMembersOrExtensionGroupMembers') as UntypedFormArray;
      return pagingGroupMembers;
   }

   private _canEdit: boolean;

   constructor(
      private changeDetectorRef: ChangeDetectorRef,
      private controlContainer: ControlContainer,
      private parentForm: FormGroupDirective
   ) {
      super();
   }

   ngOnDestroy(): void {
      this.extensionPagingGroup = null;
   }

   ngOnInit(): void {
      this.form = <UntypedFormGroup>this.controlContainer.control;
      this.extensionIdsToExclude = this.extension ? [this.extension.extensionId] : [];
      copyNameControlToShortNameAndDisplayName(this.parentForm.form, this.form);
   }

   trackBy(item: ExtensionOption | null) {
      return item?.extensionId;
   }

   ngDoCheck(): void {
      if (this.parentForm.form.invalid && (this.parentForm.submitted || this.form.touched)) {
         this.form.markAllAsTouched();
         this.changeDetectorRef.markForCheck();
      }
   }
}
